import i18next from 'i18next';

import { TEMPLATE_LANGUAGES, TEMPLATE_TYPES } from 'common/constants';

export const getTemplateLanguageLabel = (language) => {
    if (language === TEMPLATE_LANGUAGES.ES_MX) return i18next.t('Spanish');
    return i18next.t('English');
};

export const getTemplateTypeLabel = (language) => {
    if (language === TEMPLATE_TYPES.BOM_TYPE) return 'BOM';
    if (language === TEMPLATE_TYPES.SYSTEM_TYPE)
        return i18next.t('System', { count: 2 });
    return i18next.t('Proposal');
};
